// extracted by mini-css-extract-plugin
export default {"card":"MenuCard_card__uZGR+","cardHeader":"MenuCard_cardHeader__sWo1G","cardContent":"MenuCard_cardContent__pI4RE","cardHover":"MenuCard_cardHover__1-9yv"};